module.exports = __webpack_public_path__ + "static/media/okitask_product.fc9388f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/okitask_product.jpg
// module id = 805
// module chunks = 0